export default __webpack_public_path__ + "static/media/spark_47.19b6de5a.png";